import React, { useState, useEffect } from 'react'
// import { mainStyles, theme } from '../../styles'
import { useDispatch, useSelector } from "react-redux"//Hooks de redux
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import { Box, Typography, styled } from '@mui/material'
import useSwiper from "use-swiper"
import "use-swiper/lib/swiper.min.css"

import { fileActions, addTitleLegoCurrent } from '../../store/actions'
import { GenericDialog, UseImage, CustomLoadingOverlay } from '../../components'
import wait_gifImg from '../../assets/wait_gif.gif'
import { coreFunctions } from '../../utils';
import { useTranslation } from 'react-i18next';

const ContainerImage = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    textAlign: 'center',
    justifyContent: 'center',
    [theme.breakpoints.only('xs')]: {
        height: '60vh',
    },
    [theme.breakpoints.only('sm')]: {
        height: '45vh',
    },
    [theme.breakpoints.only('md')]: {
        height: '50vh',
    },
    [theme.breakpoints.only('lg')]: {
        height: '55vh',
    },
    [theme.breakpoints.only('xl')]: {
        height: '65vh',
    },
}));

export default function EvidenceStartComponent(props) {
    const { useState, useEffect } = React

    const location = useLocation()
   const navigate = useNavigate()//Módulo "History" de react router

    const [fileId, setFileId] = useState(0)
    const [openHelpDialog, setOpenHelpDialog] = useState(true)//Se muestra/oculta el gif loader
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 

    const [timerSeconds, setTimerSeconds] = useState(0)
    const [timerStart, setTimerStart] = useState(false);
    const { t } = useTranslation();

    const dispatch = useDispatch()

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const file = useSelector((state) => state.FileInfo);

    useEffect(() => {
        dispatch(addTitleLegoCurrent("Evidencia de video"))
        //console.log("Entro a startcomponent "+ location.state.folioId)
        setFileId(location.state.folioId)
        dispatch(fileActions.GetFileInfo(location.state.folioId));
        setLoadView(true)
    }, [])

    useEffect(() => {
        if (file.items != undefined && loadView) {
            setLoadView(false)
            setTimerStart(true)
            setTimerSeconds(5)
            //console.log(file)
        }
    }, [file])

    useEffect(() => {
        if (timerStart) {
            if (timerSeconds == 0) {
                // //Realiza la peticion
                let nextComponent = "EvidenceComponent"
                let stageName = file.items.Stage.Name
                let stageId = file.items.Stage.Id
                let stage = file.items.Stage
                let folioId = file.items.Id
                let autoLoadVideo = true

                coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, autoLoadVideo }})
            }
            // salir cuando lleguemos a 0
            if (!timerSeconds) return;

            // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
            const intervalId = setInterval(() => {
                setTimerSeconds(timerSeconds - 1);
            }, 1000);

            // clear interval al volver a renderizar para evitar pérdidas de memoria
            return () => clearInterval(intervalId);
        }
    }, [timerSeconds, timerStart]);

    return (<GenericDialog open={openHelpDialog}
        onClose={!openHelpDialog}
        // title="Evidencia - Ubicación"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            flexDirection: 'column',
            alignItems: "center",
        }}>
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            <Typography variant="subtitle1" gutterBottom >{t("applicant_read_text")}</Typography>
            <ContainerImage>
                {timerStart &&
                    <UseImage
                        src={wait_gifImg}
                    />
                }
            </ContainerImage>
        </Box>}
    />
    )
}